import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PointsService} from '../../services/points.service';
import { RoutesService} from '../../services/routes.service';
import { RouteService} from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { Observable} from 'rxjs/Observable';
import {any} from "codelyzer/util/function";
import { AlertService} from '../../services/alert.service';
import swal from 'sweetalert2';
declare const google: any;

var originMarker: any;
var destinationMarker:any;
var directionsService: any;
var directionsDisplay: any;
var map: any;
var originLat:number;
var originLng:number;
var destinationLat:number;
var destinationLng:number;
var arrCtrlPts: any = [];
var all_overlays : any = [];

var isOriginDestinationCreated: boolean = false;
var isOriginCreated: boolean = false;
var isDestinationCreated: boolean = false;
var isRouteCreated: boolean = false;
var isOptionalRouteCreated: boolean =false;

@Component({
  selector: 'app-routetrace',
  templateUrl: './routetrace.component.html',
  styleUrls: ['./routetrace.component.css']
})
export class RoutetraceComponent implements OnInit {
 points: any = [];
 circles: any = [];
 routes: any = [];
 pointsType: any = [];
 routetrace: any = {};
 data: any = {};
 wAux: any [] = [];
 /*public nombreRuta: string;
 public direccionOrigen: string;
 public direccionDestino: string;*/
 routeId: number = -1;

 public isPtCreated=false;
 public isValid=true;
 public isCollapsed = true;
 public rId=0;
 public isDisable=true;
 constructor(
   private route: ActivatedRoute,
   private router: Router,
   private routesService: RoutesService,
   private routeService: RouteService,
   private pointsService: PointsService,
   private commonService: CommonService,
   private alertService: AlertService
 ) { }

  ngOnInit() {
    this.getRoutes();
    this.loadControlPoints();
    map = new google.maps.Map((<HTMLInputElement>document.getElementById('b-map')), {
         zoom: 7,
         center: new google.maps.LatLng(4.624335, -74.063644)
  });

 var places1 = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('originLocation')));
    console.log('places1 : ', places1)
    google.maps.event.addListener(places1, 'place_changed', () => {
     var place1 = places1.getPlace();

     var src_addr = place1.formatted_address;
     var src_lat = place1.geometry.location.lat();
     var src_long = place1.geometry.location.lng();
     originLat=src_lat;
     originLng=src_long;
     var mesg1 = "Address 1: " + src_addr;
     mesg1 += "\nLatitude: " + src_lat;
     mesg1 += "\nLongitude: " + src_long;
     this.addOriginPoint();
   });
   var places2 = new google.maps.places.Autocomplete((<HTMLInputElement>document.getElementById('destinationLocation')));
   google.maps.event.addListener(places2, 'place_changed', () => {
     var place2 = places2.getPlace();

     var src_addr = place2.formatted_address;
     var src_lat = place2.geometry.location.lat();
     var src_long = place2.geometry.location.lng();
     destinationLat=src_lat;
     destinationLng=src_long;
     var mesg2 = "Address 2: " + src_addr;
     mesg2 += "\nLatitude: " + src_lat;
     mesg2 += "\nLongitude: " + src_long;
     this.addDestinationPoint();
   });
  }
  getRoutes():void{
   this.routesService.getRoutesByUsername(this.commonService.getUserName()).then(response => {
     if(response){
       this.routes = response;
       this.routes.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a must be equal to b
        return 0;
        });
     }
   });
  }
  loadControlPoints(){
    this.pointsService.getPointByUser(this.commonService.getUserName()).then(response => {
      if(response){
        var len=response.length;
        if(len>0){
           this.points=response;
           for(var i=0;i<len;i++){
               var latitude=parseFloat(response[i].latitude);
               var longitude=parseFloat(response[i].longitude);
               var coordinate = new google.maps.LatLng(latitude, longitude);
               var typePointId = response[i].id_pointType;
               var fColor;
               if(typePointId==1){
                  fColor = '#FF0000';
               }else if(typePointId==2){
                  fColor = '#800000';
               }else if(typePointId==3){
                  fColor = '#FFFF00';
               }else if(typePointId==4){
                  fColor = '#808000';
               }else if(typePointId==5){
                  fColor = '#00FF00';
               }else if(typePointId==6){
                  fColor = '#00FFFF';
               }
               var circle = new google.maps.Circle({
                  strokeColor: fColor,
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: fColor,
                  fillOpacity: 0.35,
                  center:coordinate,
                  radius: 500,
                  map: map
                });
                var infoWindowContent = '<div class="info_content">' +
                    '<p>'+response[i].name+'</p>' +
                '</div>';
                circle.info = new google.maps.InfoWindow({
                   content: infoWindowContent
                });
                google.maps.event.addListener(circle, 'click', function() {
                  this.info.setPosition(this.getCenter());
                  this.info.open(map, this);
                });
                circle.mID = response[i].id;
                this.circles.push({id:response[i].id, circle:circle});
                console.log(this.circles);
                map.setZoom(10);
                map.setCenter(coordinate);
           }
        }
      }
    });
  }

  onSelectRoute(value):void{
  /*for (var i = 0; i < this.circles.length; i++) {
         this.circles[i].circle.setMap(null);
  }*/
	if(originMarker!=null){
       originMarker.setMap(null);
       originMarker=null;
    }
	if(destinationMarker!=null){
	   destinationMarker.setMap(null);
	   destinationMarker=null;
	}
	isOriginCreated=false;
	isDestinationCreated=false;

	this.routetrace={};
	originLat=null;
	originLng=null;
	destinationLat=null;
	destinationLng=null;
	if(directionsDisplay != null) {
	   directionsDisplay.setMap(null);
	   directionsDisplay = null;
	}
	isRouteCreated=false;
	this.wAux = [];
  if(value!="0"){
      this.rId=value;
      this.routetrace.id =value;
	    this.loadRoute(value);
      this.isDisable=false;
     }else {
        this.isDisable = true;
     }
  }
  loadRoute(idRoute) {
    var waypts = [];
    this.wAux = [];
    this.routeService.getRoute(idRoute).then(response => {
      if (response) {
        this.routetrace = {};
        this.routetrace.id = response[0].id;
        var routeData = response[0].route_data;
       try {
        var str = routeData;
        var obj = JSON.parse(str);

        originLng = obj.origin.originLng;
        originLat = obj.origin.originLat;
        destinationLat = obj.destination.destinationLat;
        destinationLng = obj.destination.destinationLng;

        if (obj.waypoints.length > 0) {
           for(var i=0;i<obj.waypoints.length;i++){
             this.wAux[i]=[obj.waypoints[i][0],obj.waypoints[i][1]];
             waypts.push({
                 location: new google.maps.LatLng(obj.waypoints[i][0], obj.waypoints[i][1]),
                 stopover: true
             });
           }
           directionsService = new google.maps.DirectionsService();
           directionsDisplay = new google.maps.DirectionsRenderer({
              draggable: true,
              suppressMarkers: true
           });
           var req = {
               origin:new google.maps.LatLng(originLat, originLng),
               destination: new google.maps.LatLng(destinationLat, destinationLng),
               waypoints: waypts,
               optimizeWaypoints: true,
               travelMode: google.maps.DirectionsTravelMode.DRIVING
            };
           // directionsDisplay.setMap(map);
             directionsService.route(req, function(response, status) {
                 if (status === google.maps.DirectionsStatus.OK) {
                     directionsDisplay.setDirections(response);
                     directionsDisplay.setMap(map);
                     if(originMarker!=null){
                        originMarker.setMap(null);
                        originMarker = null;
                     }
                     if(destinationMarker!=null){
                        destinationMarker.setMap(null);
                        destinationMarker = null;
                     }
                     var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
                     var coordinateDestination=new google.maps.LatLng(destinationLat, destinationLng);
                     originMarker = new google.maps.Marker({
                       position: coordinateOrigin,
                       map: map
                     });
                     var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
                     destinationMarker = new google.maps.Marker({
                       position: coordinateDestination,
                       icon:pinImage,
                       map: map
                     });
                 }
             });
             isRouteCreated = true;
             isOriginCreated = true;
             isDestinationCreated = true;
             map.setZoom(10);
             map.setCenter(new google.maps.LatLng(originLat, originLng));
        }else{
           directionsService = new google.maps.DirectionsService();
           directionsDisplay = new google.maps.DirectionsRenderer({
              draggable: true,
              suppressMarkers: true
           });
           var request = {
               origin:new google.maps.LatLng(originLat, originLng),
               destination: new google.maps.LatLng(destinationLat, destinationLng),
               travelMode: google.maps.DirectionsTravelMode.DRIVING
            };
            directionsDisplay.setMap(map);
             directionsService.route(request, function(response, status) {
                 if (status === google.maps.DirectionsStatus.OK) {
                     directionsDisplay.setDirections(response);
                     directionsDisplay.setMap(map);
                     if(originMarker!=null){
                        originMarker.setMap(null);
                        originMarker = null;
                     }
                     if(destinationMarker!=null){
                        destinationMarker.setMap(null);
                        destinationMarker = null;
                     }
                     var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
                     var coordinateDestination=new google.maps.LatLng(destinationLat, destinationLng);
                     originMarker = new google.maps.Marker({
                       position: coordinateOrigin,
                       map: map
                     });
                     var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
                     destinationMarker = new google.maps.Marker({
                       position: coordinateDestination,
                       icon:pinImage,
                       map: map
                     });

                 }
             });
             map.setZoom(10);
             map.setCenter(new google.maps.LatLng(originLat, originLng));
             isRouteCreated = true;
             isOriginCreated = true;
             isDestinationCreated = true;
         }
        }catch(err) {
        }
      }
    });
  }
  addOriginPoint(){
   if(isOriginCreated==false){
     //if (!originLat || !originLng) return;

     var coordinate = new google.maps.LatLng(originLat, originLng);
     if (originMarker)
     {
     }
     else
     {
       //create a marker
       var infoWindowContent1 = '<div class="info_content">' +
           '<p> Ubicación: '+(<HTMLInputElement>document.getElementById('originLocation')).value+'</p>' +
       '</div>';
       var infoWindow1 = new google.maps.InfoWindow({
          content: infoWindowContent1
       });
       originMarker = new google.maps.Marker({
         position: coordinate,
         map: map,
         draggable: true
       });
       google.maps.event.addListener(originMarker, 'click', function() {
         infoWindow1.open(map, originMarker);
       });
       google.maps.event.addListener(originMarker, 'dragend', function(marker){
         var latLng = marker.latLng;
         originLat = latLng.lat();
         originLng = latLng.lng();
         //alert(originLat+" "+originLng);
      });
      isOriginCreated=true;
     }
  }else{
    swal({
      title: "Ya se ha creado un punto de origen.",
      text: '',
      type: 'warning'
     }).catch(swal.noop);
  }
 }
 addDestinationPoint(){
  if(isDestinationCreated==false){
    //if (!destinationLat || !destinationLng) return;

     var coordinate = new google.maps.LatLng(destinationLat, destinationLng);
     if (destinationMarker)
     {
     }
     else
     {
       //create a marker
       var infoWindowContent2 = '<div class="info_content">' +
           '<p> Ubicación: '+(<HTMLInputElement>document.getElementById('destinationLocation')).value+'</p>' +
       '</div>';
       var infoWindow2 = new google.maps.InfoWindow({
          content: infoWindowContent2
       });
       var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
       destinationMarker = new google.maps.Marker({
         position: coordinate,
         icon:pinImage,
         map: map,
         draggable: true
       });
       google.maps.event.addListener(destinationMarker, 'click', function() {
         infoWindow2.open(map, destinationMarker);
       });
       google.maps.event.addListener(destinationMarker, 'dragend', function(marker){
         var latLng = marker.latLng;
         destinationLat = latLng.lat();
         destinationLng = latLng.lng();
         //alert(destinationLat+" "+destinationLng);
       });
       isDestinationCreated=true;
     }
  }else{
    swal({
      title: "Ya se ha creado un punto de destino.",
      text: '',
      type: 'warning'
     }).catch(swal.noop);
  }
 }
 eraseRtn(){
    if(isOriginCreated || isDestinationCreated){
     let that = this;
     swal({
       title: '¿Esta seguro de borrar los puntos de origen y/o de destino, y la ruta?',
       text: '',
       type: 'warning',
       showCancelButton: true,
       confirmButtonColor: '#3085d6',
       cancelButtonColor: '#d33',
       confirmButtonText: 'Sí',
       cancelButtonText: 'No'
     }).then(function (s) {
      if(s.dismiss !== undefined){
        if (s.dismiss.toString() === 'cancel') {
        }
      }else{
        if(s.value!== undefined){
           if(s.value){
             if(originMarker!=null){
                originMarker.setMap(null);
                originMarker=null;
             }
             if(destinationMarker!=null){
                destinationMarker.setMap(null);
                destinationMarker=null;
             }
             isOriginCreated=false;
             isDestinationCreated=false;

            //that.routetrace={};
             /*if(that.routeId>-1){
               that.ruta.id = that.routeId;
             }*/
             that.routetrace.originLocation="";
             that.routetrace.destinationLocation="";
             originLat=null;
             originLng=null;
             destinationLat=null;
             destinationLng=null;
             if (directionsDisplay != null) {
              directionsDisplay.setMap(null);
              directionsDisplay = null;
             }
             isRouteCreated=false;
             that.wAux = [];
           }
        }
      }
    }).catch(swal.noop);
  }else{
    swal({
      title: "No se ha creado el punto de origen y/o de destino, o la ruta",
      text: '',
      type: 'warning'
     }).catch(swal.noop);
  }
 }
 traceRtn(){
   if(isOriginCreated&&isDestinationCreated){
     if(isRouteCreated==false){
       directionsService = new google.maps.DirectionsService();
       directionsDisplay = new google.maps.DirectionsRenderer({
          draggable: true,
          suppressMarkers: true
      });
       var request = {
           origin:new google.maps.LatLng(originLat, originLng),
           destination: new google.maps.LatLng(destinationLat, destinationLng),
           travelMode: google.maps.DirectionsTravelMode.DRIVING
        };
        directionsDisplay.setMap(map);
         directionsService.route(request, function(response, status) {
             if (status === google.maps.DirectionsStatus.OK) {
                 directionsDisplay.setDirections(response);
                 originMarker.setMap(null);
                 destinationMarker.setMap(null);
                 var coordinateOrigin = new google.maps.LatLng(originLat, originLng);
                 var coordinateDestination=new google.maps.LatLng(destinationLat, destinationLng);
                 originMarker = new google.maps.Marker({
                   position: coordinateOrigin,
                   map: map
                 });
                 var pinImage = new google.maps.MarkerImage("http://www.googlemapsmarkers.com/v1/7d2181/");
                 destinationMarker = new google.maps.Marker({
                   position: coordinateDestination,
                   icon:pinImage,
                   map: map
                 });

             }
         });
         isRouteCreated=true;
     }else{
       swal({
         title: "Ya se ha creado una ruta.",
         text: '',
         type: 'warning'
        }).catch(swal.noop);
     }
   }else if(isOriginCreated==false || isDestinationCreated==false){
     swal({
       title: "No se ha creado el punto de origen y/o de destino.",
       text: '',
       type: 'warning'
      }).catch(swal.noop);
   }
  }
  saveRtn(){
   var isSubmitted=true;
   var msg="";
   if(isRouteCreated){
     if(isSubmitted){
       let that = this;
       swal({
         title: '¿Esta seguro de guardar la ruta?',
         text: '',
         type: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#ff5370',
         confirmButtonText: 'Sí',
         cancelButtonText: 'No'
       }).then(function (s) {
         console.log(s);
        if(s.dismiss !== undefined){
          if (s.dismiss.toString() === 'cancel') {
          }
        }else{
          if(s.value!== undefined){
             if(s.value){
              
               var w=[],wp;
               var rleg = directionsDisplay.directions.routes[0].legs[0];
               that.data.origin = {'originLat': originLat, 'originLng':originLng};
               that.data.destination = {'destinationLat': destinationLat, 'destinationLng':destinationLng};
               var wp = rleg.via_waypoints;
               console.log(wp);
               console.log("---------");
               if(that.wAux.length==0){
                 for(var i=0;i<wp.length;i++){
                   w[i] = [wp[i].lat(),wp[i].lng()];
                 }
               }else{
                 for(var i=0;i<that.wAux.length;i++){
                   w[i] = [that.wAux[i][0],that.wAux[i][1]];
                 }
                 var j=that.wAux.length;
                 for(var i=0;i<wp.length;i++){
                   w[j] = [wp[i].lat(),wp[i].lng()];
                   j++;
                 }
               }
               console.log(w);
               that.data.waypoints = w;
               that.routetrace.Route_data=JSON.stringify(that.data);
               console.log(that.routetrace);

               var polyline = new google.maps.Polyline({
                 path: [],
                 strokeColor: '#FF0000',
                 strokeWeight: 3
               });

         

               var bounds = new google.maps.LatLngBounds();
               var legs = directionsDisplay.directions.routes[0].legs;
               for (var i = 0; i < legs.length; i++) {
                 var steps = legs[i].steps;
                 for (var j = 0; j < steps.length; j++) {
                   var nextSegment = steps[j].path;
                   for (var k = 0; k < nextSegment.length; k++) {
                     polyline.getPath().push(nextSegment[k]);
                     bounds.extend(nextSegment[k]);
                   }
                 }
              }

               var pathArr = polyline.getPath();
               var codeStr = '';
               for (var i = 0; i < pathArr.length; i++){
                   codeStr += '(' + pathArr.getAt(i).lat() + ',' + pathArr.getAt(i).lng() + ')' ;
                   if (i !== pathArr.length-1) {
                       codeStr += ',';
                   };
                /*   var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(pathArr.getAt(i).lat(), pathArr.getAt(i).lng()),
                    map: map,
                 });*/
               }
               console.log('codeStr : : : ', codeStr)

               var param = {
                   "Id" : that.routetrace.id,
                   "Route_data" : that.routetrace.Route_data,
                   "RoutePoints" : codeStr,
               };
               console.log('param : : : : ', param);

               that.routeService.updateRouteData(param).then(response =>{
                 if (response) {
                   if (response.status == 'EXITO') {
                     swal({
                       title: 'Se ha guardado la ruta exitosamente',
                       text: '',
                       type: 'success'
                      }).catch(swal.noop);
                   }
                 }
               });
             }
          }
        }
      }).catch(swal.noop);

     }else{
       swal({
         title: msg,
         text: '',
         type: 'warning'
        }).catch(swal.noop);
     }
   }else{
     swal({
       title: "No se ha creado una ruta.",
       text: '',
       type: 'warning'
      }).catch(swal.noop);
   }
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/routetrace/routetrace.component.ts